import { getToolNamesSet, FORBIDDEN_MUTATION_TOOLS, FORBIDDEN_SAVE_TOOLS } from './registry';
import { HANDLERS as CORE_HANDLERS } from './executorCore';
import { EXTENDED_HANDLERS } from './executorExtended';

const ALL_HANDLERS = { ...CORE_HANDLERS, ...EXTENDED_HANDLERS };

export async function executeTool(toolName, args, ctx) {
  const names = getToolNamesSet();
  if (FORBIDDEN_MUTATION_TOOLS.indexOf(toolName) >= 0) {
    return { ok: false, message: `不允许跨页操作: ${toolName}` };
  }
  if (FORBIDDEN_SAVE_TOOLS.indexOf(toolName) >= 0) {
    return { ok: true, data: { skipped: true } };
  }
  if (ctx.previewMode || (ctx.sandbox && ctx.sandbox.isActive())) {
    if (toolName === 'history.snapshot') {
      return { ok: true, data: { skipped: true } };
    }
  }
  if (!names.has(toolName)) {
    return { ok: false, message: `未知 Tool: ${toolName}` };
  }
  const handler = ALL_HANDLERS[toolName];
  if (!handler) {
    return { ok: false, message: `Tool 尚未实现: ${toolName}` };
  }
  try {
    const result = handler(args || {}, ctx);
    if (result && typeof result.then === 'function') {
      return await result;
    }
    return result;
  } catch (e) {
    return { ok: false, message: e.message || String(e) };
  }
}

export async function executePlan(steps, ctx) {
  const results = [];
  for (let i = 0; i < steps.length; i++) {
    const step = steps[i];
    const tool = step.tool || step.name;
    const args = step.args || step.parameters || {};
    const result = await executeTool(tool, args, ctx);
    results.push({ tool, args, result });
    if (!result.ok) {
      return { ok: false, results, failedAt: i, message: result.message };
    }
  }
  return { ok: true, results };
}

export { ALL_HANDLERS };
